import React, { useEffect, useState } from "react";
import "../styles/Holiday.css";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { secretKey } from "../.././data";
import Loading from "../helpers/loading_component.js";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";

const MySwal = withReactContent(Swal2);

const AddConfRoomRes = (props) => {
  const [loading, setLoading] = useState(true);
  const [confRoomRes, setConfRoomRes] = useState([]);
  const [timer, setTimer] = useState(null);
  const [note, setNote] = useState(
    props.mode === "edit" ? props.confRoomRes.note : ""
  );
  const [date, setDate] = useState(
    props.mode === "edit"
      ? new Date(props.confRoomRes.date_from).getFullYear() +
          "-" +
          (new Date(props.confRoomRes.date_from).getMonth() + 1 < 10
            ? "0" + (new Date(props.confRoomRes.date_from).getMonth() + 1)
            : new Date(props.confRoomRes.date_from).getMonth() + 1) +
          "-" +
          (new Date(props.confRoomRes.date_from).getDate() < 10
            ? "0" + new Date(props.confRoomRes.date_from).getDate()
            : new Date().getDate())
      : new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1 < 10
            ? "0" + (new Date().getMonth() + 1)
            : new Date().getMonth() + 1) +
          "-" +
          (new Date().getDate() < 10
            ? "0" + new Date().getDate()
            : new Date().getDate())
  );
  const [timeFrom, setTimeFrom] = useState(
    props.mode === "edit"
      ? (new Date(props.confRoomRes.date_from).getHours() < 10
          ? "0" + new Date(props.confRoomRes.date_from).getHours()
          : new Date(props.confRoomRes.date_from).getHours()) +
          ":" +
          (new Date(props.confRoomRes.date_from).getMinutes() < 10
            ? "0" + new Date(props.confRoomRes.date_from).getMinutes()
            : new Date(props.confRoomRes.date_from).getMinutes())
      : "11:00"
  );
  const [dateTimeFrom, setDateTimeFrom] = useState(
    props.mode === "edit"
      ? props.confRoomRes.date_from
      : new Date(
          new Date().getFullYear() +
            "-" +
            (new Date().getMonth() + 1 < 10
              ? "0" + (new Date().getMonth() + 1)
              : new Date().getMonth() + 1) +
            "-" +
            (new Date().getDate() < 10
              ? "0" + new Date().getDate()
              : new Date().getDate()) +
            " " +
            "11:00"
        )
  );
  const [timeTo, setTimeTo] = useState(
    props.mode === "edit"
      ? (new Date(props.confRoomRes.date_to).getHours() < 10
          ? "0" + new Date(props.confRoomRes.date_to).getHours()
          : new Date(props.confRoomRes.date_to).getHours()) +
          ":" +
          (new Date(props.confRoomRes.date_to).getMinutes() < 10
            ? "0" + new Date(props.confRoomRes.date_to).getMinutes()
            : new Date(props.confRoomRes.date_to).getMinutes())
      : "12:00"
  );
  const [dateTimeTo, setDateTimeTo] = useState(
    props.mode === "edit"
      ? props.confRoomRes.date_to
      : new Date(
          new Date().getFullYear() +
            "-" +
            (new Date().getMonth() + 1 < 10
              ? "0" + (new Date().getMonth() + 1)
              : new Date().getMonth() + 1) +
            "-" +
            (new Date().getDate() < 10
              ? "0" + new Date().getDate()
              : new Date().getDate()) +
            " " +
            "12:00"
        )
  );
  const [user, setUser] = useState(
    props.mode === "edit" ? props.confRoomRes.user : props.user.name
  );
  const minDate =
    new Date().getFullYear() +
    "-" +
    (new Date().getMonth() + 1 < 10
      ? "0" + (new Date().getMonth() + 1)
      : new Date().getMonth() + 1) +
    "-" +
    (new Date().getDate() < 10
      ? "0" + new Date().getDate()
      : new Date().getDate());

  const fetchConfRoomRes = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getConfRoomRes", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setConfRoomRes(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  useEffect(() => {
    setLoading(true);
    fetchConfRoomRes();
  }, []);

  const handleDateChange = (e) => {
    setDate(e.target.value);
    setDateTimeTo(new Date(e.target.value + " " + timeTo));
    setDateTimeFrom(new Date(e.target.value + " " + timeFrom));
  };

  const handleTimeToChange = (e) => {
    setTimeTo(e.target.value);
    setDateTimeTo(new Date(date + " " + e.target.value));
  };

  const handleTimeFromChange = (e) => {
    setTimeFrom(e.target.value);
    setDateTimeFrom(new Date(date + " " + e.target.value));
  };

  const handleUserChange = (e) => {
    setUser(e.target.value);
  };

  const checkRes = () => {
    var bool = false;
    if (confRoomRes.length === 0) {
      return bool;
    } else {
      confRoomRes.map((el) => {
        if (
          (new Date(el.date_from) >= dateTimeFrom &&
            new Date(el.date_from) <= dateTimeTo) ||
          (dateTimeFrom >= new Date(el.date_from) &&
            dateTimeFrom <= new Date(el.date_to))
        ) {
          bool = true;
        }
        if (props.mode === "edit" && +el.id === +props.confRoomRes.id) {
          bool = false;
        }
      });
    }
    return bool;
  };

  const validateRes = () => {
    if (dateTimeFrom && dateTimeTo && user && dateTimeFrom < dateTimeTo) {
      return true;
    } else {
      return false;
    }
  };

  const addRes = async (e) => {
    var [hoursFrom, minutesFrom] = timeFrom.split(":");
    var [hoursTo, minutesTo] = timeTo.split(":");
    if (+hoursFrom >= 7 && +hoursFrom <= 20) {
      MySwal.fire({
        icon: "success",
        title: "Godzina rezerwacji",
        text: "musi mieścić się w zakresie: 7:00 - 20:00",
      }).then((result) => {
        return;
      });
    }
    if (+hoursTo >= 7 && +hoursTo <= 20) {
      MySwal.fire({
        icon: "success",
        title: "Godzina rezerwacji",
        text: "musi mieścić się w zakresie: 7:00 - 20:00",
      }).then((result) => {
        return;
      });
    }
    if (validateRes()) {
      if (!checkRes()) {
        var body = {
          dateFrom: dateTimeFrom,
          dateTo: dateTimeTo,
          user: user,
          note: note,
        };

        await fetch("https://apidevkppp.ftpeople.pl/insertConfRes", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            MySwal.fire({
              icon: "success",
              title: "Dodano",
              text: "rezerwację sali",
            }).then((result) => {
              props.close();
            });
          })
          .catch((error) => {});
      } else {
        MySwal.fire({
          icon: "error",
          title: "Salka",
          text: "jest już zarezerwowana w tym czasie",
        });
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const editRes = async (e) => {
    var [hoursFrom, minutesFrom] = timeFrom.split(":");
    var [hoursTo, minutesTo] = timeTo.split(":");

    if (
      +hoursFrom >= 7 &&
      +hoursFrom <= 20 &&
      +hoursTo >= 7 &&
      +hoursTo <= 20
    ) {
      if (validateRes()) {
        if (!checkRes()) {
          var body = {
            dateFrom: dateTimeFrom,
            dateTo: dateTimeTo,
            user: user,
            id: props.confRoomRes.id,
            note: note,
          };

          await fetch("https://apidevkppp.ftpeople.pl/updateConfRes", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body),
          })
            .then((response) => response.text())
            .then((data) => {
              MySwal.fire({
                icon: "success",
                title: "Zmieniono",
                text: "rezerwację sali",
              }).then((result) => {
                props.close();
              });
            })
            .catch((error) => {});
        } else {
          MySwal.fire({
            icon: "error",
            title: "Salka",
            text: "jest już zarezerwowana w tym czasie",
          });
        }
      } else {
        MySwal.fire({
          icon: "error",
          title: "Błąd",
          text: "Wypełnij wymagane pola formularza",
        });
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Godzina rezerwacji",
        text: "musi mieścić się w zakresie: 7:00 - 20:00",
      }).then((result) => {});
    }
  };

  const deleteRes = async (e) => {
    var body = {
      id: props.confRoomRes.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deleteConfRes", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Usunięto",
          text: "rezerwację sali",
        }).then((result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  return (
    <>
      {loading ? (
        <Loading id="popUpLoading" />
      ) : (
        <div className="mainContainerBlockPopUp">
          <div className="closeBox">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>
          {props.user.role === "admin" ? (
            <>
              <div className="inputBox">
                <div className="inputCol_1">
                  <label>
                    Pracownik <span className="requiredStar">*</span>
                  </label>
                  <select
                    type="date"
                    id="name"
                    name="name"
                    value={user}
                    onChange={handleUserChange}
                  >
                    {props.users.map((el) => (
                      <>
                        <option key={el.login} value={el.name}>
                          {el.name}
                        </option>
                      </>
                    ))}
                  </select>
                </div>
              </div>
            </>
          ) : (
            ""
          )}
          <>
            <div className="inputBox" style={{ width: "93%" }}>
              <div className="inputCol_2">
                <label>
                  Data rezerwacji<span className="requiredStar">*</span>
                </label>
                <input
                  type="date"
                  id="date"
                  name="date"
                  value={date}
                  onChange={handleDateChange}
                  min={minDate}
                />
              </div>
            </div>
            <div className="inputBox" style={{ width: "93%" }}>
              <div className="inputCol_2">
                <div className="inputCol_2">
                  <label>
                    Godzina rozpoczęcia <span className="requiredStar">*</span>
                  </label>
                  <input
                    type="time"
                    id="time"
                    name="time"
                    value={timeFrom}
                    onChange={handleTimeFromChange}
                  />
                </div>
              </div>
              <div className="inputCol_2">
                <label>
                  Godzina zakończenia <span className="requiredStar">*</span>
                </label>
                <input
                  type="time"
                  id="time"
                  name="time"
                  value={timeTo}
                  onChange={handleTimeToChange}
                />
              </div>
            </div>
            <div className="inputBox">
              <div className="inputCol_1">
                <label>Notatka</label>
                <textarea
                  spellCheck="false"
                  className="textAreaNote"
                  type="text"
                  id="url"
                  name="url"
                  value={note}
                  onChange={(e) => {
                    setNote(e.target.value);
                  }}
                />
              </div>
            </div>
          </>

          <div className="saveBoxAP" style={{ display: "flex", gap: "20px" }}>
            {props.mode !== "edit" ? (
              <button className="paymentMenuButton" onClick={addRes}>
                zapisz
              </button>
            ) : (
              ""
            )}
            {props.mode === "edit" ? (
              <>
                <button className="paymentMenuButton" onClick={editRes}>
                  Edytuj
                </button>
                <button className="paymentMenuButton" onClick={deleteRes}>
                  Usuń
                </button>
              </>
            ) : (
              ""
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default AddConfRoomRes;
